module.exports = __webpack_public_path__ + "static/media/setting.8331917a.svg";